import i18n, { InitOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';

import { Language } from '../interfaces/language.type';

const en = require('./locales/en.json');
const es = require('./locales/es.json');
const pt_BR = require('./locales/pt-BR.json');

export const availableLanguages = [Language.EN, Language.ES, Language.PT_BR];

const initConfig: InitOptions = {
  fallbackLng: Language.EN,
  lng: Language.EN,
  debug: false,
  cache: {
    enabled: true,
  },
  resources: {
    [Language.EN]: en,
    [Language.PT_BR]: pt_BR,
    [Language.ES]: es,
  },
  interpolation: {
    prefix: '${',
    suffix: '}',
  },
};

i18n.use(initReactI18next).init(initConfig);

export function initI18n(lang = Language.EN) {
  if (i18n.isInitialized) {
    return;
  }

  return i18n.use(initReactI18next).init({
    ...initConfig,
    lng: lang,
  });
}

export default i18n;
